import { CopilotAnswerResponse } from './types';
import { laravelAxios } from 'src/config/axios/laravelAxios';
import poliApiGatewayRequest from 'src/utils/poliApiGatewayRequest';

export class CopilotAnswerService {
  static async createCopilotAnswer(
    messages: any[],
    contact_uuid: string
  ): Promise<any> {
    const url = `/ia/messages/suggest_answer`;

    const data = {
      contactUuid: contact_uuid,
      messages: messages, // enviar as ultimas 20 mensagens
    };

    const response = await poliApiGatewayRequest.post<CopilotAnswerResponse>(
      url,
      data
    );

    return response.data;
  }

  static async updateContactCopilot(
    suggest_answer: boolean,
    contact_uuid: string
  ): Promise<any> {
    const url = `/suggest-answer/${contact_uuid}`;

    const data = {
      suggest_answer,
    };

    const response = await laravelAxios.post(url, data);

    return response.data;
  }

  static async getContactCopilot(contact_uuid: string): Promise<any> {
    const url = `/suggest-answer/${contact_uuid}`;

    const response = await laravelAxios.get<any>(url);

    return response.data;
  }
}
